var map = {
	"./about-us/desktop/AboutUsBanner.jpg": 1306,
	"./about-us/desktop/AboutUsBanner2.jpg": 942,
	"./about-us/desktop/CategoryBanner1.jpg": 1897,
	"./about-us/desktop/CategoryBanner2-v2.jpg": 559,
	"./about-us/desktop/CategoryBanner2.jpg": 2551,
	"./about-us/desktop/CategoryBanner3.jpg": 7503,
	"./about-us/desktop/CategoryBanner4.jpg": 9866,
	"./about-us/mobile/AboutUsBanner2_mobile.jpg": 9265,
	"./about-us/mobile/AboutUsBanner_mobile.jpg": 1007,
	"./about-us/mobile/CategoryBanner1_mobile.jpg": 5230,
	"./about-us/mobile/CategoryBanner2-v2_mobile.jpg": 8811,
	"./about-us/mobile/CategoryBanner2_mobile.jpg": 1316,
	"./about-us/mobile/CategoryBanner3_mobile.jpg": 2025,
	"./about-us/mobile/CategoryBanner4_mobile.jpg": 6324,
	"./contact-us/desktop/ContactUsBanner.jpg": 599,
	"./contact-us/mobile/ContactUsBanner_mobile.jpg": 5995,
	"./home/desktop/HeroBanner1.jpg": 3199,
	"./home/desktop/HeroBanner10.jpg": 9680,
	"./home/desktop/HeroBanner11.jpg": 7046,
	"./home/desktop/HeroBanner12.jpg": 6919,
	"./home/desktop/HeroBanner13.jpg": 345,
	"./home/desktop/HeroBanner2.jpg": 8410,
	"./home/desktop/HeroBanner3.jpg": 4407,
	"./home/desktop/HeroBanner4.jpg": 7056,
	"./home/desktop/HeroBanner5.jpg": 386,
	"./home/desktop/HeroBanner6.jpg": 9834,
	"./home/desktop/HeroBanner7.jpg": 8667,
	"./home/desktop/HeroBanner8.jpg": 9849,
	"./home/desktop/HeroBanner9.jpg": 9848,
	"./home/desktop/ProductBanner1.jpg": 6506,
	"./home/desktop/ProductBanner10.jpg": 199,
	"./home/desktop/ProductBanner11.jpg": 4129,
	"./home/desktop/ProductBanner12.jpg": 2034,
	"./home/desktop/ProductBanner2.jpg": 8254,
	"./home/desktop/ProductBanner3.jpg": 55,
	"./home/desktop/ProductBanner4.jpg": 2823,
	"./home/desktop/ProductBanner5.jpg": 4858,
	"./home/desktop/ProductBanner6.jpg": 2189,
	"./home/desktop/ProductBanner7.jpg": 231,
	"./home/desktop/ProductBanner8.jpg": 2142,
	"./home/desktop/ProductBanner9.jpg": 6824,
	"./home/home-image-1.jpg": 5559,
	"./home/home-image-1v2.jpg": 3987,
	"./home/home-image-2.jpg": 6413,
	"./home/home-image-2v2.jpg": 1412,
	"./home/mobile/HeroBanner10_mobile.jpg": 1919,
	"./home/mobile/HeroBanner11_mobile.jpg": 657,
	"./home/mobile/HeroBanner12_mobile.jpg": 7650,
	"./home/mobile/HeroBanner13_mobile.jpg": 2297,
	"./home/mobile/HeroBanner1_mobile.jpg": 2580,
	"./home/mobile/HeroBanner2_mobile.jpg": 4474,
	"./home/mobile/HeroBanner3_mobile.jpg": 8922,
	"./home/mobile/HeroBanner4_mobile.jpg": 8782,
	"./home/mobile/HeroBanner5_mobile.jpg": 9279,
	"./home/mobile/HeroBanner6_mobile.jpg": 5597,
	"./home/mobile/HeroBanner7_mobile.jpg": 7974,
	"./home/mobile/HeroBanner8_mobile.jpg": 5656,
	"./home/mobile/HeroBanner9_mobile.jpg": 1280,
	"./home/mobile/ProductBanner10_mobile.jpg": 7768,
	"./home/mobile/ProductBanner11_mobile.jpg": 6370,
	"./home/mobile/ProductBanner12_mobile.jpg": 2247,
	"./home/mobile/ProductBanner1_mobile.jpg": 2673,
	"./home/mobile/ProductBanner2_mobile.jpg": 5477,
	"./home/mobile/ProductBanner3_mobile.jpg": 2346,
	"./home/mobile/ProductBanner4_mobile.jpg": 1077,
	"./home/mobile/ProductBanner5_mobile.jpg": 6456,
	"./home/mobile/ProductBanner6_mobile.jpg": 8642,
	"./home/mobile/ProductBanner7_mobile.jpg": 5116,
	"./home/mobile/ProductBanner8_mobile.jpg": 9753,
	"./home/mobile/ProductBanner9_mobile.jpg": 1582,
	"./logo/logo.png": 8050,
	"./logo/logoWhite.png": 9829,
	"./product-guide/icons/arrows-icon.png": 9565,
	"./product-guide/icons/battery-icon.png": 1536,
	"./product-guide/icons/bulb-icon.png": 7354,
	"./product-guide/icons/car-icon.png": 8542,
	"./product-guide/icons/fan-icon.png": 2451,
	"./product-guide/icons/fridge-icon.png": 9023,
	"./product-guide/icons/laptop-icon.png": 8525,
	"./product-guide/icons/phone-icon.png": 4968,
	"./product-guide/icons/plug-icon.png": 5821,
	"./product-guide/icons/router-icon.png": 5259,
	"./product-guide/icons/solar-icon.png": 4599,
	"./product-guide/icons/tv-icon.png": 2928,
	"./product-guide/icons/usb-icon.png": 6947,
	"./product-guide/products/1200W.png": 858,
	"./product-guide/products/1200W_PPS_table-image.png": 1878,
	"./product-guide/products/1200W_reskin_PPS_table-image.png": 3637,
	"./product-guide/products/1500W_PPS_table-image.png": 8990,
	"./product-guide/products/150W_PPS_table-image.png": 3917,
	"./product-guide/products/200W_PPS_table-image.png": 8913,
	"./product-guide/products/2200W_PPS_table-image.png": 6983,
	"./product-guide/products/3000W_PPS_table-image.png": 8059,
	"./product-guide/products/300W.png": 4551,
	"./product-guide/products/300W_PPS_table-image.png": 7685,
	"./product-guide/products/300W_reskin_PPS_table-image.png": 1141,
	"./product-guide/products/3600W_PPS_table-image.png": 6626,
	"./product-guide/products/400W_PPS_table-image.png": 7315,
	"./product-guide/products/600W.png": 4826,
	"./product-guide/products/600W_PPS_table-image.png": 4494,
	"./product-guide/products/600W_reskin_PPS_table-image.png": 7817,
	"./product-guide/products/700W_PPS_table-image.png": 1614,
	"./product-range/desktop/ProductRangeBanner.jpg": 9814,
	"./product-range/desktop/accessories/Magneto_100WSolarPanel_Desktop.jpg": 8069,
	"./product-range/desktop/accessories/Magneto_120WSolarPanel_Desktop.jpg": 9733,
	"./product-range/desktop/accessories/Magneto_12Way_SurgeProtector_Desktop.jpg": 4316,
	"./product-range/desktop/accessories/Magneto_4Way_SurgeProtector_Desktop.jpg": 8893,
	"./product-range/desktop/accessories/Magneto_8Way_SurgeProtector_Desktop.jpg": 1466,
	"./product-range/desktop/accessories/Magneto_BugZapper_Desktop.jpg": 6414,
	"./product-range/desktop/accessories/Magneto_DBBoard_Desktop.jpg": 7880,
	"./product-range/desktop/accessories/Magneto_Fridge_SurgeProtector_Desktop.jpg": 4426,
	"./product-range/desktop/accessories/Magneto_SurgeProtector_Desktop.jpg": 7904,
	"./product-range/desktop/accessories/Magneto_UltraAlkaline_AA.jpg": 6747,
	"./product-range/desktop/accessories/Magneto_UltraAlkaline_AAA.jpg": 5683,
	"./product-range/desktop/generators/Magneto_2-8kwGenerator.jpg": 7554,
	"./product-range/desktop/generators/Magneto_6kwGenerator_Desktop.jpg": 5010,
	"./product-range/desktop/generators/Magneto_7kwGenerator.jpg": 5836,
	"./product-range/desktop/lighting/Magneto_100WSolarPoweredSecurityLight.jpg": 6911,
	"./product-range/desktop/lighting/Magneto_2in1Torch_Desktop.jpg": 4529,
	"./product-range/desktop/lighting/Magneto_80WSolarPoweredSecurityLight.jpg": 2438,
	"./product-range/desktop/lighting/Magneto_AllPurposeCompactLEDTorch.jpg": 8957,
	"./product-range/desktop/lighting/Magneto_CompactFloodlight_Desktop.jpg": 6412,
	"./product-range/desktop/lighting/Magneto_LEDComboPack.jpg": 8522,
	"./product-range/desktop/lighting/Magneto_LEDCompact.jpg": 808,
	"./product-range/desktop/lighting/Magneto_LEDCompact_Desktop.jpg": 7786,
	"./product-range/desktop/lighting/Magneto_MagneticLEDLight_Desktop.jpg": 1774,
	"./product-range/desktop/lighting/Magneto_NightExplorerLEDHeadlight.jpg": 642,
	"./product-range/desktop/lighting/Magneto_NightExplorerLEDHeadlight2_Desktop.jpg": 9868,
	"./product-range/desktop/lighting/Magneto_RechargeableBulbBayonette_Desktop.jpg": 2803,
	"./product-range/desktop/lighting/Magneto_RechargeableBulbScrew_Desktop.jpg": 3309,
	"./product-range/desktop/lighting/Magneto_RechargeableLEDSolar.jpg": 70,
	"./product-range/desktop/lighting/Magneto_RechargeableLamp_Desktop.jpg": 830,
	"./product-range/desktop/lighting/Magneto_RechargeableLantern.jpg": 9353,
	"./product-range/desktop/lighting/Magneto_RechargeableLithiumLEDLantern.jpg": 1938,
	"./product-range/desktop/lighting/Magneto_SensorStripLight.jpg": 5734,
	"./product-range/desktop/lighting/Magneto_SolarChargeLEDLightingSystem_Desktop.jpg": 8863,
	"./product-range/desktop/lighting/Magneto_SolarHomeSystem.jpg": 1631,
	"./product-range/desktop/lighting/Magneto_StringLights2.jpg": 3007,
	"./product-range/desktop/lighting/Magneto_Xtreme.jpg": 8308,
	"./product-range/desktop/lighting/Magneto_XtremeLEDSpotlight.jpg": 7276,
	"./product-range/desktop/product-images/Magneto_Product1200W.jpg": 9518,
	"./product-range/desktop/product-images/Magneto_Product1200W_2.jpg": 7947,
	"./product-range/desktop/product-images/Magneto_Product1200W_reskin.jpg": 7002,
	"./product-range/desktop/product-images/Magneto_Product1500W.jpg": 5086,
	"./product-range/desktop/product-images/Magneto_Product150W.jpg": 3886,
	"./product-range/desktop/product-images/Magneto_Product200W.jpg": 9863,
	"./product-range/desktop/product-images/Magneto_Product2200W.jpg": 8486,
	"./product-range/desktop/product-images/Magneto_Product3000W.jpg": 9894,
	"./product-range/desktop/product-images/Magneto_Product300W.jpg": 4946,
	"./product-range/desktop/product-images/Magneto_Product300W_2.jpg": 4155,
	"./product-range/desktop/product-images/Magneto_Product300W_reskin.jpg": 1360,
	"./product-range/desktop/product-images/Magneto_Product3600W.jpg": 6881,
	"./product-range/desktop/product-images/Magneto_Product400W.jpg": 1910,
	"./product-range/desktop/product-images/Magneto_Product600W.jpg": 444,
	"./product-range/desktop/product-images/Magneto_Product600W_2.jpg": 1733,
	"./product-range/desktop/product-images/Magneto_Product600W_reskin.jpg": 5065,
	"./product-range/desktop/product-images/Magneto_Product700W.jpg": 7536,
	"./product-range/desktop/security/Magneto_BulletSolarCamera_Desktop.jpg": 272,
	"./product-range/desktop/security/Magneto_OmniViewSolarCamera_Desktop.jpg": 1627,
	"./product-range/mobile/ProductRangeBanner_mobile.jpg": 8104,
	"./product-range/mobile/accessories/Magneto_100WSolarPanel_mobile.jpg": 2937,
	"./product-range/mobile/accessories/Magneto_120WSolarPanel_mobile.jpg": 1547,
	"./product-range/mobile/accessories/Magneto_12Way_SurgeProtector_Mobile.jpg": 9448,
	"./product-range/mobile/accessories/Magneto_4Way_SurgeProtector_Mobile.jpg": 7430,
	"./product-range/mobile/accessories/Magneto_8Way_SurgeProtector_Mobile.jpg": 5604,
	"./product-range/mobile/accessories/Magneto_BugZapper_Mobile.jpg": 5256,
	"./product-range/mobile/accessories/Magneto_DBBoard_Mobile.jpg": 9241,
	"./product-range/mobile/accessories/Magneto_Fridge_SurgeProtector_Mobile.jpg": 6622,
	"./product-range/mobile/accessories/Magneto_SurgeProtector_mobile.jpg": 3994,
	"./product-range/mobile/accessories/Magneto_UltraAlkaline_AAA_mobile.jpg": 4598,
	"./product-range/mobile/accessories/Magneto_UltraAlkaline_AA_mobile.jpg": 9864,
	"./product-range/mobile/generators/Magneto_2-8kwGenerator_mobile.jpg": 9817,
	"./product-range/mobile/generators/Magneto_6kwGenerator_Mobile.jpg": 3826,
	"./product-range/mobile/generators/Magneto_7kwGenerator_mobile.jpg": 1198,
	"./product-range/mobile/lighting/Magneto_100WSolarPoweredSecurityLight_mobile.jpg": 5989,
	"./product-range/mobile/lighting/Magneto_2in1Torch_Mobile.jpg": 3555,
	"./product-range/mobile/lighting/Magneto_80WSolarPoweredSecurityLight_mobile.jpg": 8852,
	"./product-range/mobile/lighting/Magneto_AllPurposeCompactLEDTorch_mobile.jpg": 7177,
	"./product-range/mobile/lighting/Magneto_CompactFloodlight_Mobile.jpg": 2940,
	"./product-range/mobile/lighting/Magneto_LEDComboPack_mobile.jpg": 1718,
	"./product-range/mobile/lighting/Magneto_LEDCompact_mobile.jpg": 8862,
	"./product-range/mobile/lighting/Magneto_MagneticLEDLight_Mobile.jpg": 7666,
	"./product-range/mobile/lighting/Magneto_NightExplorerLEDHeadlight2_Mobile.jpg": 1904,
	"./product-range/mobile/lighting/Magneto_NightExplorerLEDHeadlight_mobile.jpg": 3064,
	"./product-range/mobile/lighting/Magneto_RechargeableBulbBayonette_mobile.jpg": 615,
	"./product-range/mobile/lighting/Magneto_RechargeableBulbScrew_mobile.jpg": 3687,
	"./product-range/mobile/lighting/Magneto_RechargeableLEDSolar_mobile.jpg": 5573,
	"./product-range/mobile/lighting/Magneto_RechargeableLamp_Mobile.jpg": 8388,
	"./product-range/mobile/lighting/Magneto_RechargeableLantern_mobile.jpg": 1920,
	"./product-range/mobile/lighting/Magneto_RechargeableLithiumLEDLantern_mobile.jpg": 369,
	"./product-range/mobile/lighting/Magneto_SensorStripLight_mobile.jpg": 7005,
	"./product-range/mobile/lighting/Magneto_SolarChargeLEDLightingSystem_Mobile.jpg": 224,
	"./product-range/mobile/lighting/Magneto_SolarHomeSystem_mobile.jpg": 1958,
	"./product-range/mobile/lighting/Magneto_StringLights2_mobile.jpg": 6774,
	"./product-range/mobile/lighting/Magneto_XtremeLEDSpotlight_mobile.jpg": 202,
	"./product-range/mobile/lighting/Magneto_Xtreme_mobile.jpg": 3627,
	"./product-range/mobile/product-images/Magneto_Product1200W_2_mobile.jpg": 3548,
	"./product-range/mobile/product-images/Magneto_Product1200W_mobile.jpg": 5788,
	"./product-range/mobile/product-images/Magneto_Product1200W_reskin_mobile.jpg": 6559,
	"./product-range/mobile/product-images/Magneto_Product1500W_mobile.jpg": 9691,
	"./product-range/mobile/product-images/Magneto_Product150W_mobile.jpg": 6014,
	"./product-range/mobile/product-images/Magneto_Product200W_mobile.jpg": 8669,
	"./product-range/mobile/product-images/Magneto_Product2200W_mobile.jpg": 3652,
	"./product-range/mobile/product-images/Magneto_Product3000W_mobile.jpg": 3665,
	"./product-range/mobile/product-images/Magneto_Product300W_2_mobile.jpg": 6175,
	"./product-range/mobile/product-images/Magneto_Product300W_mobile.jpg": 4003,
	"./product-range/mobile/product-images/Magneto_Product300W_reskin_mobile.jpg": 6094,
	"./product-range/mobile/product-images/Magneto_Product3600W_mobile.jpg": 278,
	"./product-range/mobile/product-images/Magneto_Product400W_mobile.jpg": 594,
	"./product-range/mobile/product-images/Magneto_Product600W_2_mobile.jpg": 6597,
	"./product-range/mobile/product-images/Magneto_Product600W_mobile.jpg": 1880,
	"./product-range/mobile/product-images/Magneto_Product600W_reskin_mobile.jpg": 435,
	"./product-range/mobile/product-images/Magneto_Product700W_mobile.jpg": 1581,
	"./product-range/mobile/security/Magneto_BulletSolarCamera_Mobile.jpg": 8755,
	"./product-range/mobile/security/Magneto_OmniViewSolarCamera_Mobile.jpg": 7886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;